class KeenSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.sliderId = this.querySelector('[id^="Slider-"]')?.id;
    this.sliderThumbnailsId = this.querySelector(
      '[id^="Slider-Thumbnails-"]'
    )?.id;
    this.currentCounter = this.querySelector(".slider-counter--current");
    this.counterDots = this.querySelectorAll(".slider-counter__link");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.autoplayButtonIsSetToPlay = false;

    this.slider = new KeenSlider(`#${this.sliderId}`, {
      loop: this.dataset.sliderLoop == "true" ? true : false,
      slides: {
        origin: this.dataset.slidesOriginMobile
          ? this.dataset.slidesOriginMobile
          : this.dataset.slidesOrigin,
        perView: this.dataset.slidesPerViewMobile,
        spacing: this.dataset.sliderGapMobile,
      },
      breakpoints: {
        "(min-width: 750px)": {
          slides: {
            origin: this.dataset.slidesOriginDesktop
              ? this.dataset.slidesOriginDesktop
              : this.dataset.slidesOrigin,
            perView: this.dataset.slidesPerViewDesktop,
            spacing: this.dataset.sliderGapDesktop,
          },
          disabled: this.dataset.sliderDesktopDisabled || false,
        },
      },
    });

    if (this.dataset.hasThumbnailSlider) {
      this.thumbnails = new KeenSlider(
        `#${this.sliderThumbnailsId}`,
        {
          initial: 0,
          slides: {
            perView: this.dataset.thumbnailSlidesPerViewDesktop,
            spacing: this.dataset.thumbnailSliderGapMobile,
          },
          breakpoints: {
            "(min-width: 750px)": {
              slides: {
                perView: this.dataset.thumbnailSlidesPerViewDesktop,
                spacing: this.dataset.thumbnailSliderGapDesktop,
              },
            },
          },
        },
        [this.createThumbnailPlugin(this.slider)]
      );
    }

    this.prevButton?.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton?.addEventListener("click", this.onButtonClick.bind(this));
    this.counterDots?.forEach((counter, index) => {
      counter.addEventListener("click", () => {
        this.onCounterClick(index);
      });
    });
    this.init();
  }

  init() {
    this.dataset.sliderAutoplay == "true" && this.setAutoPlay();
    this.slider.on("slideChanged", this.onSlideChanged.bind(this));
  }

  createThumbnailPlugin(main) {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove("active");
        });
      }
      function addActive(idx) {
        slider.slides[idx].classList.add("active");
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener("click", () => {
            main.moveToIdx(idx);
          });
        });
      }

      slider.on("created", () => {
        addActive(slider.track.details.rel);
        addClickEvents();
        main.on("animationStarted", (main) => {
          removeActive();
          const next = main.animator.targetIdx || 0;
          addActive(main.track.absToRel(next));
          slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
        });
      });
    };
  }

  onButtonClick(event) {
    if (this.dataset.sliderMoveEntireRow == "true") {
      this.moveEntireRow(event.currentTarget.name);
      return;
    }

    this.moveOneSlide(event.currentTarget.name);
  }

  moveOneSlide(target) {
    if (target === "next") {
      this.slider.moveToIdx(this.slider.track.details.rel + 1);
    }
    if (target === "previous") {
      this.slider.moveToIdx(this.slider.track.details.rel - 1);
    }
  }

  moveEntireRow(target) {
    let nextSlideIdx;
    if (target === "next") {
      nextSlideIdx =
        this.slider.track.details.rel +
        Math.floor(this.slider.options.slides.perView);
      this.slider.moveToIdx(nextSlideIdx);
    }

    if (target === "previous") {
      nextSlideIdx =
        this.slider.track.details.rel -
        Math.floor(this.slider.options.slides.perView);
      this.slider.moveToIdx(nextSlideIdx);
    }
  }

  onCounterClick(index) {
    this.slider.moveToIdx(index);
  }

  onSlideChanged() {
    if (this.currentCounter) {
      this.currentCounter.textContent = this.slider.track.details.rel + 1;
    }

    if (this.counterDots.length > 0) {
      this.counterDots.forEach((dot) => {
        dot.classList.remove("slider-counter__link--active");
        dot.removeAttribute("aria-current");
      });
      this.counterDots[this.slider.track.details.rel].classList.add(
        "slider-counter__link--active"
      );
      this.counterDots[this.slider.track.details.rel].setAttribute(
        "aria-current",
        true
      );
    }

    if (
      this.prevButton?.classList.contains("slider-button--visually-hidden") &&
      this.slider.track.details.rel != 0
    ) {
      this.prevButton?.classList.remove("slider-button--visually-hidden");
    }
  }

  setAutoPlay() {
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton?.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
    }
    this.autoplayButtonIsSetToPlay = true;
    this.play();
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion?.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton || this.dataset.sliderAutoplay == "true") {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton?.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider?.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(() => {
      if (this.dataset.sliderMoveEntireRow == "true") {
        this.moveEntireRow("next");
        return;
      }
      this.slider.next();
    }, this.dataset.sliderAutoplaySpeed);
  }

  pause() {
    this.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }
}
customElements.define("keen-slider-component", KeenSliderComponent);
